import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { PhoneInputData } from '../../PhoneInput/PhoneInput';

type UserVerificationSendCodeProps = {
  phone: PhoneInputData;
  onDone: () => void;
};

export const UserPhoneVerificationSuccess = ({ phone, onDone }: UserVerificationSendCodeProps) => {
  const { t } = useTranslation();

  const formatNumber = (phoneNumber: PhoneInputData) =>
    `+${phoneNumber?.parsed?.countryCallingCode} ${phoneNumber?.parsed?.nationalNumber}`;

  return (
    <>
      <h2 className="user-verification-modal-title">{t('components.phone-verification.verified')}</h2>

      <div className="user-verification-modal-body pt-1">
        <span dangerouslySetInnerHTML={{ __html: t('components.phone-verification.number-verified', { phone: formatNumber(phone) }) }} />

        {/* Actions */}
        <div className="user-verification-modal-actions mt-4">
          <Button variant="contained" color="primary" onClick={onDone} fullWidth size="large">
            {t('components.phone-verification.done')}
          </Button>
        </div>
      </div>
    </>
  );
};
